/// <amd-module name="SuiteCommerce.StockNotifications.Subscription.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Subscription.Configuration", ["require", "exports", "SuiteCommerce.StockNotifications.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SubscriptionConfiguration = void 0;
    var SubscriptionConfiguration = /** @class */ (function (_super) {
        __extends(SubscriptionConfiguration, _super);
        function SubscriptionConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(SubscriptionConfiguration, "isMandatoryName", {
            get: function () {
                return this.get('stockNotifications.pdp.mandatoryName');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionConfiguration, "isMandatoryLastName", {
            get: function () {
                return this.get('stockNotifications.pdp.mandatoryLastName');
            },
            enumerable: false,
            configurable: true
        });
        return SubscriptionConfiguration;
    }(Configuration_1.Configuration));
    exports.SubscriptionConfiguration = SubscriptionConfiguration;
});
